<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 哮天系统 
                </el-breadcrumb-item>
				<el-breadcrumb-item>设备关键字</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.keyType" placeholder="请选择关键字类型" filterable>
					<el-option key="" label="请选择关键字类型" value=""></el-option>
					<el-option key="0" label="设备" value="0"></el-option>
					<el-option key="1" label="品牌" value="1"></el-option>
					<el-option key="2" label="元器件" value="2"></el-option>
				</el-select>&nbsp;
				<el-input v-model="query.name" placeholder="关键字" class="handle-input mr10"></el-input>
                <el-select v-model="query.status" placeholder="请选择状态" filterable>
					<el-option key="" label="请选择状态" value=""></el-option>
					<el-option key="true" label="点亮" value="true"></el-option>
					<el-option key="false" label="未点亮" value="false"></el-option>
				</el-select>&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>&nbsp;&nbsp;
				<router-link  :to="{path:'/equipment-product-mapping'}" v-if="controll['equipment-product-mapping']"><el-button
                            type="text"
							v-if="controll['equipment-product-mapping']"
                        >关联元器件</el-button></router-link>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="keyType" label="关键字类型" width="180">
					<template slot-scope="scope">
                        {{scope.row.keyType===0?"设备":(scope.row.keyType===1?"品牌":"元器件")}}
                    </template>
				</el-table-column>
                <el-table-column prop="name" label="关键字">
					<template slot-scope="scope">
						<el-tag :type='success' v-if="scope.row.status">
							{{scope.row.alias? scope.row.name + " / " + scope.row.alias:scope.row.name}}
						</el-tag>
						<span v-if="scope.row.status == undefined || scope.row.status == false">{{scope.row.alias? scope.row.name + " / " + scope.row.alias:scope.row.name}}</span>
                    </template>
				</el-table-column>
				<el-table-column prop="remark" label="备注"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
						<el-button
                            type="text"
                            icon="el-icon-star-on"
                            @click="updateStatus(scope.$index, scope.row)"
                         v-if="controll['update-status'] && (scope.row.status == undefined || scope.row.status == false)">点亮</el-button>
						<el-button
                            type="text"
                            icon="el-icon-star-off"
                            @click="updateStatus(scope.$index, scope.row)"
                        v-if="controll['update-status'] && scope.row.status">关闭</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if="controll['edit']"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete']"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="warning"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
					v-if="controll['delete-batch']"
                >批量删除</el-button>
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog :title="title" :visible.sync="editVisible" width="50%">
            <el-form ref="form" :model="form" label-width="110px" :rules="rules">
				<el-form-item label="类型" prop="keyType">
					<el-select v-model="form.keyType">
						<el-option key="" label="请选择关键字类型" value=""></el-option>
						<el-option key=0 label="设备" :value=0></el-option>
						<el-option key=1 label="品牌" :value=1></el-option>
						<el-option key=2 label="元器件" :value=2></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="名称" prop="name">
					<el-input v-model="form.name" placeholder="多个关键字用','分割"></el-input>
				</el-form-item>
				<el-form-item label="别名" prop="alias">
					<el-input v-model="form.alias" placeholder="多个关键时别名不建议添加"></el-input>
				</el-form-item>
				<el-form-item label="备注" prop="remark">
					<el-input type=textarea :rows=4 v-model="form.remark"> </el-input>
				</el-form-item>
				<el-form-item label="预测使用元器件" v-if="form.keyType==0">
					<el-row>
						<el-col :span="24">
							<el-select v-model="form.typeId" placeholder="请选择元器件类型" @change="onChangeTypeId" style="width:180px;">
								<el-option key="" label="请选择元器件类型" value=""></el-option>
								<el-option v-for="item in productTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
							</el-select>&nbsp;
							<el-select v-model="form.seriesId" placeholder="请选择元器件系列" filterable style="width:180px;">
								<el-option key="" label="请选择元器件系列" value=""></el-option>
								<el-option v-for="item in productSeriesKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
							</el-select>&nbsp;
							<el-input v-model="form.productName" placeholder="元器件" class="handle-input mr10" style="width:200px;"></el-input>&nbsp;
							<el-button type="primary" icon="el-icon-lx-add" @click="handleBind">添加</el-button>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-table
								:data="bindProducts"
								border
								class="table"
								header-cell-class-name="table-header"
								:cell-style="{padding:1+'px'}"
								stripe
								style="margin-top:20px;"
							>
								<el-table-column prop="id" label="序号" width="50">
									<template slot-scope="scope">
										{{scope.$index + 1}}
									</template>
								</el-table-column>
								<el-table-column prop="productRemark" label="名称"></el-table-column>
								<el-table-column label="操作" width="200" align="center">
									<template slot-scope="scope">
										<el-button
											type="text"
											icon="el-icon-delete"
											class="red"
											@click="removeBindProducts(scope.$index, scope.row)"
										>删除</el-button>
									</template>
								</el-table-column>
							</el-table>
						</el-col>
					</el-row>
				</el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchPotentialResourcesKeyData, savePotentialResourcesKey, getPotentialResourcesKey, deletePotentialResourcesKey, 
getProduct, getEnumValueKV, getProductSeriesKV, updatePotentialResourcesKeyStatus} from '../../../api/index';
export default {
    name: 'potential-resources-key',
    data() {
        return {
            query: {
                pageIndex: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
			title:"",
			rules: {
                name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
            },
			bindProducts:[],
			productTypeKV:{},
			productSeriesKV:{},
			productTypeEnumCode:1003,
			controll:{}
        };
    },
    created() {
		this.controll = getControll("potential-resources-key");
        this.getData();
		this.getProductType();
    },
    methods: {
		//获取产品类型
		getProductType() {
			getEnumValueKV(this.productTypeEnumCode).then(res => {
				if (res.code == 0 ) {
					this.productTypeKV = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			});
		},
		//产品类型变更
		onChangeTypeId(value) {
			this.productSeriesKV = {};
			if (!value) {
				return;
			}
			getProductSeriesKV(value).then(res => {
				if (res.code == 0 ) {
					this.productSeriesKV = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			});
		},
        // 获取分页数据
        getData() {
            fetchPotentialResourcesKeyData(this.query).then(res => {
                if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取资讯数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
			this.$set(this.query, 'pageNum', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deletePotentialResourcesKey([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要删除的记录！`);
				return;
			}
            let ids = [];
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			this.$confirm('确定要删除选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deletePotentialResourcesKey(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
				})
				.catch(() => {});
        },
        //添加操作
		handleAdd() {
			this.form = {};
			this.bindProducts = [];
			this.title = "添加新纪录";
			this.editVisible = true;
		},
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
			this.title = "编辑";
			this.fileList = [];
			getPotentialResourcesKey(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					if (res.data.equipmentProductMappings) {
						this.bindProducts = res.data.equipmentProductMappings;
					} else {
						this.bindProducts = [];
					}
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					if (this.bindProducts.length > 0) {
						this.form.equipmentProductMappings = this.bindProducts
					}
					savePotentialResourcesKey(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							if (typeof(this.form.id) == "undefined") {
								this.getData();
							} else {
								this.$set(this.tableData, this.idx, this.form);
							}
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		getProductName(source, key) {
			let index = source.findIndex(item => {
				if (item.key === key) {
					return true;
				}
			});
			if (index === -1) {
				return "";
			} else {
				return source[index].value;
			}
		},
		handleBind() {
			if (!this.form.typeId) {
				this.$message.error('请选择产品！');
				return;
			}
			let bind = {};
			bind["typeId"] = this.form.typeId;
			let productRemark = this.getProductName(this.productTypeKV, this.form.typeId);
			if (this.form.seriesId) {
				bind["seriesId"] = this.form.seriesId;
				productRemark = productRemark + "/" + this.getProductName(this.productSeriesKV, this.form.seriesId);
			}
			if (this.form.productName) {
				bind["productName"] = this.form.productName;
				productRemark = productRemark + "/" + this.form.productName;
			}
			bind["productRemark"] = productRemark;
			this.bindProducts.push(bind);			
		},
		removeBindProducts(index, row) {
			this.$confirm('确定要删除该的记录吗？', '提示', {
                type: 'warning'
            }).then(() => {
					let index = this.bindProducts.findIndex(item => {
						if (item.productRemark === row.productRemark ) {
							return true;
						}
					}); 
					if (index === -1) {
						this.$message.error(`产品绑定记录异常！`);
						return;
					}
					this.bindProducts.splice(index, 1);
				})
				.catch(() => {});
		},
		updateStatus(index, row) {
			updatePotentialResourcesKeyStatus(row.id).then(res => {
				if (res.code == 0) {
					this.$message.success((row.status?'关闭':'点亮') + '成功');
					this.$set(row, 'status', !row.status)
				} else {
					this.$message.error((row.status?'关闭':'点亮') + `失败！` + res.message);
				}
			}); 
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
